var exports = {
  "jD": "x31de4314--214114--cont",
  "vW": "x31de4314--214114--inner",
  "nM": "x31de4314--214114--row",
  "RA": "x31de4314--214114--liquidity-points",
  "MD": "x31de4314--214114--bet",
  "Kk": "x31de4314--214114--icon",
  "x6": "x31de4314--214114--button",
  "uN": "x31de4314--214114--tip",
};

module.exports = exports;
